import { ArrowDown } from "lucide-react";
import { Section, highlight } from "./shared";

function Flowchart({ chart, regex }) {
  if (!chart?.steps?.length) return null;
  return (
    <div className="mt-3 border border-black/10 bg-white p-4">
      {chart.title && (
        <p className="font-mono text-[10px] uppercase tracking-widest mb-3 text-zinc-500">
          {highlight(chart.title, regex)}
        </p>
      )}
      <div className="flex flex-col items-start gap-1.5">
        {chart.steps.map((step, i) => (
          <div key={i} className="w-full">
            <div className="inline-block px-3 py-1.5 border border-black bg-[#DBEAFE]/60 text-sm">
              {highlight(step, regex)}
            </div>
            {i < chart.steps.length - 1 && (
              <div className="my-0.5 pl-4"><ArrowDown className="w-3 h-3 text-[#3B82F6]" /></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export function FlowchartsSection({ flowcharts, regex }) {
  if (!flowcharts?.length) return null;
  return (
    <Section label="Flowcharts">
      <div className="grid sm:grid-cols-2 gap-3">
        {flowcharts.map((f, i) => <Flowchart key={i} chart={f} regex={regex} />)}
      </div>
    </Section>
  );
}
